export enum AuthErrorType {
  /**
   * Email confirmation token has expired.
   */
  ExpiredConfirmation = 101,
}
